export interface ProductOption {
  value: string;
  viewValue: string;
  price: number;
}

export interface ExtraService {
  type: string;
  info: string;
  price: number;
}

export const PRODUCT_OPTIONS: ProductOption[] = [
  { value: 'PSVING', viewValue: 'Charter Ving parkering med transfer', price: 0 },
  { value: 'PSVING1VECKA', viewValue: 'Charter Ving parkering 1 vecka med transfer', price: 522 },
  {
    value: 'PSVING2VECKA',
    viewValue: 'Charter Ving parkering 2 veckor med transfer',
    price: 747
  },
  {
    value: 'PSVING3VECKA',
    viewValue: 'Charter Ving parkering 3 veckor med transfer',
    price: 1070
  },
  {
    value: 'PSVING4VECKA',
    viewValue: 'Charter Ving parkering 4 veckor med transfer',
    price: 1390
  },

  { value: 'PSSCANDIC', viewValue: 'Charter Scandic parkering med transfer', price: 0 },
  {
    value: 'PSSCANDIC1VECKA',
    viewValue: 'Charter Scandic parkering 1 vecka med transfer',
    price: 450
  },

  { value: 'PSTUI', viewValue: 'Charter Tui parkering med transfer', price: 0 },
  { value: 'PSTUI1VECKA', viewValue: 'Charter Tui parkering 1 vecka med transfer', price: 522 },
  { value: 'PSTUI2VECKA', viewValue: 'Charter Tui parkering 2 veckor med transfer', price: 747 },
  { value: 'PSTUI3VECKA', viewValue: 'Charter Tui parkering 3 veckor med transfer', price: 1070 },
  { value: 'PSTUI4VECKA', viewValue: 'Charter Tui parkering 4 veckor med transfer', price: 1390 }
];

export const EXTRA_SERVICE: ExtraService[] = [
  { type: 'Handtvätt in och ut inkl. uppvärmd bil', info: 'Asfaltsbortagning ingår', price: 800 },
  { type: 'Is- och snöfri bil inkl.uppvärmning', info: 'Asfaltsbortagning ingår', price: 300 },
  { type: 'Laddplats för Elbil', info: 'Asfaltsbortagning ingår', price: 150 },
  { type: 'Utvädring handtvätt', info: 'Asfaltsbortagning ingår', price: 350 },
  { type: 'Helrekond', info: 'Asfaltsbortagning ingår', price: 6500 }
];
